export default __webpack_public_path__ + "static/dermalogica-e36d5114b5ce99d4fff173f375e7691d.jpg";